export function form () {
  const form = document.querySelector('.js-form');

  if(!form) return;

  const formSubmit = form.querySelector('.js-formSubmit');
  formSubmit.disabled = true;

  const formConfirm = form.querySelector('.js-formConfirm');
  formConfirm.addEventListener('change', () => {
    // checkedであればdisabledをfalseに、そうでなければtrueにする
    formSubmit.disabled = !formConfirm.checked;
  });
}